export default {
  clickToPlace: 'Click the map to place the site',
  clickToAddCorner: 'Click the map to add the first corner',
  geofenceRadius: 'Geofence radius',
  pickerHint: 'Click the map or drag the marker to set the site centre. Phones inside the dashed circle count as on site.',
  searchFailed: 'Address search failed',
  shapeCircle: 'Circle',
  shapePolygon: 'Polygon',
  clearShape: 'Clear shape',
  polygonCorners: '{count} corners',
  enclosingCircle: 'wake-up circle {meters} m',
  polygonHint: 'Click the map to add a corner, drag a corner to move it, right-click a corner to remove it, or click a midpoint to add one there. Phones wake up inside the faint circle; the polygon decides who is on site.',
  polygonTooFew: 'A polygon needs at least 3 corners.',
  polygonSelfIntersecting: 'The edges of the polygon cross each other.',
  polygonTooSmall: 'The polygon is too small to stand in.',
  polygonTooLarge: 'The polygon is too large: it must fit inside a 5 km circle.',
}
